import { gql } from 'apollo-boost'

const RefreshToken = gql`
  mutation RefreshToken (
    $refresh_token: String!
  ) {
    refresh_token (
      refresh_token: $refresh_token
    ) {
      access_token
      refresh_token
    }
  }
`

export default RefreshToken
